<template>
  <div id="top">
    <HeaderStyle title='科大智能资料下载平台' className="header-border-bottom" />
    <div class="section content">
      <div class="r-header">
        <el-input v-model="searchObj.fileName" placeholder="文件名称" clearable
          @keyup.enter.native="getList('s')"></el-input>
        <el-cascader v-model="cascaderValue" :options="options" placeholder="文件类型/格式" clearable
          :props="{ expandTrigger: 'hover', checkStrictly: true }"></el-cascader>
        <el-button type="primary" @click="getList('s')">查询</el-button>
      </div>
      <el-table v-loading="tableLoading" border="" :data="tableData" size="small" style="width: 100%;">
        <el-table-column type="index" label="序号" align="center" :index='indexMethods' width="50">
        </el-table-column>
        <el-table-column prop="fileName" label="文件名称" align="center">
          <template slot-scope="scope">
            {{scope.row.fileName ? scope.row.fileName.substring(0, scope.row.fileName.lastIndexOf(".")) : ''}}
          </template>
        </el-table-column>
        <el-table-column prop="fileType" label="文件类型" align="center">
          <template slot-scope="scope">
            {{['文档', '视频'][scope.row.fileType*1]}}
          </template>
        </el-table-column>
        <el-table-column prop="fileSubType" label="文件格式" align="center">
        </el-table-column>
        <el-table-column prop="ctime" label="上传日期" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center" width="240">
          <template slot-scope="scope">
           <el-button
              v-if="scope.row.fileSubType === 'docx' || scope.row.fileSubType === 'xlsx'"
              @click="goPreview(scope.row)" type="text" color="#F56C6C" class="el-icon-data-board" size="medium">
              预览
            </el-button>
<!--           <el-button
              @click="goPreview(scope.row)" type="text" color="#F56C6C" class="el-icon-data-board" size="medium">
              预览
            </el-button> -->
           <a v-else :href="scope.row.fileUrl" target="_blank">
              <el-button type="text" color="#F56C6C" class="el-icon-data-board" size="medium">
                预览
              </el-button>
            </a>
            <a :href="`${baseURL}/file-manage/download?id=${scope.row.id}`">
              <el-button type="text" class="el-icon-download" size="medium">
                下载
              </el-button>
            </a>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next" :total="total"
        @current-change="handleCurrentChange"></el-pagination>
    </div>
    <el-dialog title="预览" :visible.sync="dialogVisible" width="60%" top="8vh" @close="dialogClose">
      <div class="file-preview" v-loading="previewLoading" element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <VueOfficeDocx v-if="previewType === 'docx'" style="height: 500px;" :src="src" />
        <VueOfficeExcel v-else-if="previewType === 'xlsx'" style="height: 500px;" :src="src" />
        <!-- <iframe scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true" width="100%" height="600" v-else :src="`${rowUrl}`"></iframe> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <a :href="`${baseURL}/file-manage/download?id=${rowID}`" style="margin-left: 10px;">
          <el-button type="primary">
            下载
          </el-button>
        </a>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import $, {
    type
  } from 'jquery'
  import axios from 'axios'
  import HeaderStyle from '../../components/HeaderStyle.vue'

  import VueOfficeDocx from '@vue-office/docx'
  import '@vue-office/docx/lib/index.css'

  import VueOfficeExcel from '@vue-office/excel'
  import '@vue-office/excel/lib/index.css'

  // const headers = {
  //   'Content-Type': 'application/json',
  //   'Authorization': 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhZG1pbiIsImlhdCI6MTcwMTg1MTY1NiwiZXhwIjoxNzAyNDU2NDU2fQ.EaUGaLLtxwI4j1lhwZ0JuS3Pm62O7weF07srfznHxT5eXOS3hlt8gaEVRgZcmSEVIimtRF8qq8TPeNB9IEbYjg'
  // }

  export default {
    components: {
      HeaderStyle,
      VueOfficeDocx,
      VueOfficeExcel
    },
    data() {
      return {
        baseURL: axios.defaults.baseURL,
        rowUrl: null,
        rowID: null,
        previewType: null,
        dialogVisible: false,
        tableLoading: false,
        previewLoading: false,
        src: '',
        tableData: [],
        total: null,
        cascaderValue: [],
        searchObj: {
          current: 1,
          size: 10,
          fileName: '',
          fileType: '',
          fileSubType: ''
        },
        options: [{
          value: '0',
          label: '文档',
          children: [{
            value: 'pdf',
            label: 'pdf'
          }, {
            value: 'xlsx',
            label: 'xlsx'
          }, {
            value: 'docx',
            label: 'docx'
          }]
        }, {
          value: '1',
          label: '视频',
          children: [{
            value: 'mp4',
            label: 'mp4'
          }]
        }]
      }
    },
    mounted() {
      this.getList()
    },
    methods: {
      dialogClose() {
        this.src = null
      },
      async goPreview(row) {
        this.rowID = row.id
        this.rowUrl = row.fileUrl
        this.dialogVisible = true
        this.previewType = row.fileSubType
        if ( this.previewType === 'docx' || this.previewType === 'xlsx') {
          this.previewLoading = true
          this.xhrequest(this.baseURL + '/file-manage/convertToBlob?fileUrl=' + row.fileUrl, src => {
            this.src = src
            setTimeout(()=> this.previewLoading = false, 500)
          })
        } 
      },
      async xhrequest(url, callback) {
        let DownUrl = url;
        let data = await fetch(DownUrl)
          .then((response) => response.blob())
          .then((res) => {
            //获取文件格式
            var index = DownUrl.lastIndexOf(".");
            //获取文件后缀判断文件格式
            var fileType = DownUrl.substr(index + 1);
            let blod = new Blob([res]);
            if (typeof callback == "function") {
              callback(blod, fileType)
            }
          });
        return data
      },
      getList(e) {
        this.tableLoading = true
        this.searchObj.fileType = this.cascaderValue[0]
        this.searchObj.fileSubType = this.cascaderValue[1]
        e ? this.searchObj.current = 1 : null
        axios.post('/file-manage/findList', this.searchObj).then(res => {
          this.tableData = res.data.data.records
          this.total = res.data.data.total
        }).finally(err => {
          this.tableLoading = false
        })
      },
      handleCurrentChange(val) {
        this.searchObj.current = val
        this.getList()
      },
      indexMethods(index) {
        return (this.searchObj.current - 1) * this.searchObj.size + index + 1;
      }
    }
  }
</script>

<style scoped>
  #top {
    height: 100%;
    overflow: hidden;
  }

  .content {
    margin: 30px;
    position: relative;
    height: calc(100% - 200px);
    overflow-y: auto;
  }

  .r-header {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
    padding: 30px 0;
    background: #fafafa;
  }

  .r-header .el-input,
  .el-select,
  .el-cascader {
    width: 260px;
    margin-right: 10px;
  }

  .r-header>>>.el-button {
    margin-left: 0;
  }

  .el-pagination {
    padding: 20px 0 0 0;
  }
  

  .el-table .cell .el-button {
    margin-right: 20px;
  }

  .file-preview {
    width: 100%;
    height: 80%;
    border: 1px dashed #007acc;
    background: gray;
  }
</style>